import React from 'react';
import SEOHeadNative from '../components/SEOHeadNative';

const Habilitation: React.FC = () => {
  return (
    <div>
      <SEOHeadNative
        title="Formation Habilitation Électrique - OZARKSELEC"
        description="Formation habilitation électrique NF C18-510 à Viesly. Habilitation B0, BS, BR, B1, B2, BC. Formateur certifié, formation dans vos locaux ou les nôtres. Validité 3 ans."
        keywords="formation habilitation électrique, NF C18-510, habilitation B0, BS, BR, formation électrique Aisne, habilitation électrique Nord, formation sécurité électrique"
        canonical="/habielec"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Formation Habilitation Électrique",
          "description": "Formation habilitation électrique NF C18-510 : B0, BS, BR, B1, B2, BC. Formateur certifié, validité 3 ans.",
          "provider": {
            "@type": "ElectricalContractor",
            "name": "OZARKS ELEC",
            "url": "https://ozarkselec.com"
          },
          "areaServed": ["Aisne", "Thiérache", "Caudrésis", "Catésis", "Nord"],
          "serviceType": "Formation habilitation électrique"
        }}
      />
      <div className="r t-rec t-rec_pt_90 t-rec_pb_90" style={{paddingTop: '90px', paddingBottom: '90px'}}>
        <div className="t-container">
          <div className="t-col t-col_8 t-prefix_2">
            <div className="t-align_center">
              <h1 className="t-title t-title_xs ozarks-blue-dark">
                Habilitation <span className="ozarks-blue-medium">Électrique</span>
              </h1>
              
              <div style={{marginTop: '60px', textAlign: 'left'}}>
                <div style={{marginBottom: '40px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>⚡ Formation Habilitation Électrique</h3>
                  <p className="ozarks-gray" style={{lineHeight: '1.7'}}>
                    OZARKSELEC propose des formations d'habilitation électrique conformes à la norme NF C18-510. 
                    Nos formations sont dispensées par des formateurs certifiés et permettent d'obtenir les habilitations 
                    nécessaires pour travailler en sécurité sur les installations électriques.
                  </p>
                </div>

                <div style={{marginBottom: '40px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>📋 Types d'habilitations proposées</h3>
                  <div style={{marginLeft: '20px'}}>
                    <div style={{marginBottom: '15px'}}>
                      <h4 className="ozarks-blue-medium" style={{marginBottom: '8px', fontWeight: 500}}>• Habilitation B0, H0, H0V</h4>
                      <p className="ozarks-gray" style={{lineHeight: '1.6', fontSize: '15px'}}>
                        Personnel non électricien travaillant dans un environnement électrique
                      </p>
                    </div>
                    <div style={{marginBottom: '15px'}}>
                      <h4 className="ozarks-blue-medium" style={{marginBottom: '8px', fontWeight: 500}}>• Habilitation BS, BE Manoeuvre</h4>
                      <p className="ozarks-gray" style={{lineHeight: '1.6', fontSize: '15px'}}>
                        Personnel effectuant des interventions élémentaires et manoeuvres
                      </p>
                    </div>
                    <div style={{marginBottom: '15px'}}>
                      <h4 className="ozarks-blue-medium" style={{marginBottom: '8px', fontWeight: 500}}>• Habilitation BR, B1, B2, BC</h4>
                      <p className="ozarks-gray" style={{lineHeight: '1.6', fontSize: '15px'}}>
                        Personnel électricien pour interventions générales et travaux
                      </p>
                    </div>
                    <div style={{marginBottom: '15px'}}>
                      <h4 className="ozarks-blue-medium" style={{marginBottom: '8px', fontWeight: 500}}>• Recyclage et Maintien des compétences</h4>
                      <p className="ozarks-gray" style={{lineHeight: '1.6', fontSize: '15px'}}>
                        Renouvellement des habilitations existantes selon la réglementation
                      </p>
                    </div>
                  </div>
                </div>

                <div style={{marginBottom: '40px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>🎯 Déroulement de la formation</h3>
                  <div style={{marginLeft: '20px'}}>
                    <div style={{marginBottom: '12px'}}>
                      <span className="ozarks-blue-medium" style={{fontWeight: 500}}>1. Partie théorique :</span>
                      <span className="ozarks-gray"> Réglementation, risques électriques, mesures de prévention</span>
                    </div>
                    <div style={{marginBottom: '12px'}}>
                      <span className="ozarks-blue-medium" style={{fontWeight: 500}}>2. Partie pratique :</span>
                      <span className="ozarks-gray"> Mise en situation, utilisation des équipements de sécurité</span>
                    </div>
                    <div style={{marginBottom: '12px'}}>
                      <span className="ozarks-blue-medium" style={{fontWeight: 500}}>3. Évaluation :</span>
                      <span className="ozarks-gray"> Test théorique et pratique pour validation des acquis</span>
                    </div>
                    <div>
                      <span className="ozarks-blue-medium" style={{fontWeight: 500}}>4. Certification :</span>
                      <span className="ozarks-gray"> Remise du titre d'habilitation et avis d'habilitation</span>
                    </div>
                  </div>
                </div>

                <div style={{marginBottom: '40px'}}>
                  <h3 className="ozarks-blue-dark" style={{marginBottom: '15px', fontWeight: 600}}>📍 Modalités pratiques</h3>
                  <div style={{backgroundColor: 'var(--ozarks-light-gray)', padding: '20px', borderRadius: '10px'}}>
                    <div style={{marginBottom: '15px'}}>
                      <strong className="ozarks-blue-dark">Durée :</strong>
                      <span className="ozarks-gray"> De 7h à 21h selon le niveau d'habilitation</span>
                    </div>
                    <div style={{marginBottom: '15px'}}>
                      <strong className="ozarks-blue-dark">Lieu :</strong>
                      <span className="ozarks-gray"> Dans nos locaux ou directement dans votre entreprise</span>
                    </div>
                    <div style={{marginBottom: '15px'}}>
                      <strong className="ozarks-blue-dark">Effectif :</strong>
                      <span className="ozarks-gray"> Maximum 12 participants par session</span>
                    </div>
                    <div>
                      <strong className="ozarks-blue-dark">Validité :</strong>
                      <span className="ozarks-gray"> 3 ans (recyclage obligatoire)</span>
                    </div>
                  </div>
                </div>

                <div style={{backgroundColor: 'var(--ozarks-blue-light)', padding: '25px', borderRadius: '12px', marginTop: '40px'}}>
                  <h4 className="ozarks-blue-dark" style={{marginBottom: '15px', textAlign: 'center'}}>📞 Demandez votre devis de formation</h4>
                  <div style={{textAlign: 'center'}}>
                    <p className="ozarks-gray" style={{lineHeight: '1.7', marginBottom: '20px'}}>
                      Formations adaptées à vos besoins, planifiées selon vos disponibilités.
                      <br />Formateur certifié et expérimenté dans le domaine électrique.
                    </p>
                    <div style={{display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap'}}>
                      <p className="ozarks-blue-dark" style={{margin: 0, fontWeight: 600}}>
                        📱 +33 630 98 45 78
                      </p>
                      <p className="ozarks-blue-dark" style={{margin: 0, fontWeight: 600}}>
                        📧 ozarkselec@gmail.com
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Habilitation;